'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var YouTubeIframeLoader = require("youtube-iframe");
var Youtube;
(function (Youtube) {
    var MyYoutube = /** @class */ (function () {
        function MyYoutube() {
            var self = this;
            window.onload = function () {
                self.resizePlayer();
            };
            window.addEventListener('resize', function () {
                self.resizePlayer();
            });
            YouTubeIframeLoader.load(function (YT) {
                new YT.Player('bulletYoutube', // 埋め込む場所の指定
                {
                    videoId: 'ytx55W7FG20',
                    playerVars: {
                        rel: 0,
                        loop: 0,
                        playlist: 'ytx55W7FG20',
                        controls: 0,
                        autoplay: 1,
                        showinfo: 0,
                    },
                    events: {
                        'onReady': self.onPlayerReady
                    }
                });
            });
        }
        //プレイ準備完了後
        MyYoutube.prototype.onPlayerReady = function (event) {
            // 画面サイズ
            var wins = { w: 0, h: 0 };
            // PC画面サイズ比 高さ÷幅 16:9 なら 0.5625
            var ratio;
            wins.w = $(window).width();
            if (wins.w >= 768) {
                event.target.playVideo();
                event.target.mute();
            }
            event.target.mute();
            // 読み込み完了後に背景をオフ
            $('.top-view__block').css('background-image', 'none');
            if (wins.w >= 768) {
                $('#trigVolume').show();
            }
        };
        // PCトップ動画サイズ
        MyYoutube.prototype.resizePlayer = function () {
            // 画面サイズ
            var wins = { w: 0, h: 0 };
            // PC画面サイズ比 高さ÷幅 16:9 なら 0.5625
            var ratio;
            wins.w = $(window).width();
            if ($('#player').length > 0 && wins.w >= 768) {
                wins.h = $(window).height();
                ratio = wins.h / wins.w;
                /**
                 * Youtube iframe の位置サイズを決定
                 * 幅, 高さ, marginTop, marginLeft
                 */
                var yt = { w: wins.w, h: wins.h, mt: 0, ml: 0 };
                if (ratio > 0.5625) {
                    yt.w = yt.h / 0.5625;
                    yt.ml = -Math.floor((yt.w - wins.w) / 2);
                }
                else if (ratio < 0.5625) {
                    yt.h = yt.w * 0.5625;
                    yt.mt = -Math.floor((yt.h - wins.h) / 2);
                }
                $('#youtube').css({
                    width: yt.w,
                });
                $('.youtube__box__body').css({
                    marginLeft: yt.ml,
                });
                $('.top-view__box').css({
                    height: wins.h,
                });
                $('#trigVolume').show();
            }
            else {
                $('#trigVolume').hide();
                $('.top-view__box').css({
                    height: 'auto',
                });
            }
        };
        return MyYoutube;
    }());
    Youtube.MyYoutube = MyYoutube;
})(Youtube || (Youtube = {}));
exports.default = Youtube;
